import React, { CSSProperties, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { FieldLabel } from './FieldLabel';
import { Error, Wrapper } from './Wrapper.styled';

export interface IFieldWrapper {
  label?: string;
  name: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  error?: string;
  children: ReactNode;
  tooltip?: ReactNode;
  margin?: string;
  backgroundColor?: string;
  width?: string;
  flexDirection?: string;
  fontSize?: string;
  paddingLabel?: string;
  isVisible?: boolean;
  justifyContentLabel?: string;
  labelStyle?: CSSProperties;
  placeholderColor?: string;
}

export const FieldWrapper = ({
  label,
  name,
  isRequired,
  isDisabled,
  error,
  children,
  tooltip,
  margin,
  backgroundColor,
  width,
  flexDirection,
  fontSize,
  paddingLabel,
  isVisible,
  justifyContentLabel,
  labelStyle,
  placeholderColor,
}: IFieldWrapper) => {
  const { t } = useTranslation();

  return (
    <Wrapper
      $margin={margin}
      $backgroundColor={backgroundColor}
      $width={width}
      $flexDirection={flexDirection}
      $isVisible={isVisible}
      placeholderColor={placeholderColor}
    >
      {label && (
        <FieldLabel
          label={label}
          name={name}
          isRequired={isRequired}
          isDisabled={isDisabled}
          hasError={!!error}
          tooltip={tooltip}
          fontSize={fontSize}
          paddingLabel={paddingLabel}
          justifyContent={justifyContentLabel}
          style={labelStyle}
        />
      )}
      {children}
      {error && <Error>{t(error)}</Error>}
    </Wrapper>
  );
};
